// extracted by mini-css-extract-plugin
module.exports = {"bladeTreaserPC":"treaser_bladeTreaserPC__ya3Ed"};